import type { CustomPromptPostProcessingType, LLMMessage } from '@/IsekaiRPG/modules/llm/llmTypes';

export class PostProcessor {
  static postProcessPrompt(messages: LLMMessage[], type: CustomPromptPostProcessingType): LLMMessage[] {
    if (!type) {
      return messages;
    }

    switch (type) {
      case 'merge':
        return this.mergeSameRoleMessages(messages);
      case 'semi':
        return this.mergeMessagesWithStrategy(messages, { strict: true, placeholders: false });
      case 'strict':
        return this.mergeMessagesWithStrategy(messages, { strict: true, placeholders: true });
      default:
        return this.mergeSameRoleMessages(messages);
    }
  }

  private static mergeSameRoleMessages(messages: LLMMessage[]): LLMMessage[] {
    const result: LLMMessage[] = [];

    for (const current of messages) {
      const content = current.content?.trim() ?? '';
      if (!content) continue;

      const previous = result[result.length - 1];
      if (previous && previous.role === current.role) {
        previous.content = `${previous.content}\n\n${content}`;
      } else {
        result.push({ role: current.role, content });
      }
    }

    return result;
  }

  private static mergeMessagesWithStrategy(
    messages: LLMMessage[],
    options: {
      strict: boolean;
      placeholders: boolean;
    },
  ): LLMMessage[] {
    const mergedMessages = this.mergeSameRoleMessages(messages);

    if (mergedMessages.length === 0) {
      return [];
    }

    if (!options.strict) {
      return mergedMessages;
    }

    const strictMessages = mergedMessages.map(message => ({ ...message }));

    for (let index = 1; index < strictMessages.length; index += 1) {
      if (strictMessages[index].role === 'system') {
        strictMessages[index].role = 'user';
      }
    }

    return this.mergeMessagesWithStrategy(strictMessages, {
      strict: false,
      placeholders: options.placeholders,
    });
  }
}
